import {
  ROLE_LABELS,
  rolesWithPermission,
  type Permission,
  type Role,
} from "@bruhat/shared";

/** Super Admin holds everything, so naming it explains nothing useful. */
const HIDDEN_FROM_EXPLANATIONS: Role[] = ["SUPER_ADMIN"];

/**
 * Turn a permission into a sentence a user can act on:
 * "Only a Company Admin, Finance Manager or Project Manager can do this."
 *
 * Hiding an action the user cannot perform makes the screen look broken. Saying
 * who *can* perform it tells them exactly whom to ask.
 */
export function explainPermission(permission: Permission): string {
  const roles = rolesWithPermission(permission)
    .filter((role) => !HIDDEN_FROM_EXPLANATIONS.includes(role))
    .map((role) => ROLE_LABELS[role]);

  if (roles.length === 0) return "This action is not available to any role.";

  const list =
    roles.length === 1
      ? roles[0]
      : `${roles.slice(0, -1).join(", ")} or ${roles[roles.length - 1]}`;

  return `You do not have permission for this. Only a ${list} can.`;
}
